<template>
  <gg-card>
    <gg-card-header>
      Manage Installations
    </gg-card-header>
    <gg-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
      >
        <template #item.softurl="{ item }">
          <a :href="item.softurl" target="_blank">{{ item.softurl }}</a>
        </template>
        <template #item.actions="{ item }">
          <gg-btn secondary @click="login(item)" :disabled="!!loadingLogin" :loading="loadingLogin === item.insid" class="mr-2">
            WP Dashboard
            <v-icon small class="ml-1">mdi-open-in-new</v-icon>
          </gg-btn>
          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on, attrs }">
              <gg-btn v-on="on" v-bind="attrs">
                Manage
                <v-icon class="ml-1">mdi-chevron-down</v-icon>
              </gg-btn>
            </template>
            <v-list>
              <v-list-item @click="showModal('password', item)">
                <v-list-item-title>Update Admin Password</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showModal('disable', item)">
                <v-list-item-title>Disable All Plugins</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showModal('delete', item)">
                <v-list-item-title>Delete Installation</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </gg-card-text>
    <admin-password-modal
      :installation="selectedInstallation"
      :opened="modals.password"
      @close="closeModal('password')"
    />
    <disable-plugins-modal
      :opened="modals.disable"
      :installation="selectedInstallation"
      @close="closeModal('disable')"
    />
    <delete-modal
      :opened="modals.delete"
      :installation="selectedInstallation"
      @close="closeModal('delete')"
      @deleted="fetchInstallations"
    />
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { makeWpLoginUrl } from '@/helpers/wp'
import AdminPasswordModal from './Modals/AdminPasswordModal'
import DisablePluginsModal from './Modals/DisablePluginsModal'
import DeleteModal from './Modals/DeleteModal'

export default {
  name: 'InstallationsList',
  components: {
    AdminPasswordModal,
    DisablePluginsModal,
    DeleteModal,
  },
  data () {
    return {
      loading: false,
      loadingLogin: false,
      headers: [
        { text: 'URL', value: 'softurl' },
        { text: 'Installation', value: 'script_name' },
        { text: 'Version', value: 'ver' },
        { text: 'Actions', value: 'actions' },
      ],
      modals: {
        password: false,
        disable: false,
        delete: false
      },
      selectedInstallation: null
    }
  },
  computed: {
    ...mapGetters({
      installations: 'hosting_wp/installations'
    }),
    items () {
      return this.installations.filter(inst => inst.script_name == 'WordPress')
    }
  },
  methods: {
    ...mapActions({
      getInstallationsList: 'hosting_wp/getInstallationsList',
      reportError: 'reportError'
    }),
    showModal (modal, installation) {
      this.selectedInstallation = installation
      this.modals[modal] = true
    },
    closeModal (modal) {
      this.selectedInstallation = null
      this.modals[modal] = false
    },
    async fetchInstallations () {
      this.loading = true
      try {
        await this.getInstallationsList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    async login ({ insid }) {
      this.loadingLogin = insid
      try {
        const loginUrl = await makeWpLoginUrl({ insid, username: this.$route.query.user })
        window.open(loginUrl, '_blank').focus()
      } catch (e) {
        if (e.message.toString().includes('window.open')) {
          this.reportError('Please, allow the pop-up windows to open in your browser settings.')
        } else {
          this.reportError(e)
        }
      } finally {
        this.loadingLogin = false
      }
    },
  },
  mounted () {
    this.fetchInstallations()
  }
}
</script>
